module.exports = {
  siteTitle: 'V for Volcano - Dr. Swetha Venugopal', // <title>
  manifestName: 'V for Volcano',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/volcano_icon.png',
  pathPrefix: `/gatsby-starter-solidstate/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Dr. Swetha Venugopal',
  subHeading:
    'Passionate volcanologist and melt inclusion enthusiast',
  // social
  socialLinks: [
    {
      icon: 'fa-linkedin',
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/swethavenugopal/',
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      display: 'swethavg3@gmail.com',
      url: 'mailto:swethavg3@gmail.com',
    },
    {
      icon: 'fa-file',
      name: 'Resume',
      display: 'Resume',
      url: 'https://vforvolcano.com/resume.pdf',
    },
  ]
};
